import { Space, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { Alert as AntAlert } from 'components/atoms/alert';
import { Loading } from 'components/atoms/loading';
import { useTranslation } from 'hooks/use-translation';

const Alert = styled(AntAlert)`
  width: 100%;
`;

export const TableLoader = () => {
  const loading = useTranslation('settings.integrations.jira.loading');

  return (
    <Alert
      message={
        <Space>
          <Loading />
          <Typography.Text>{loading}</Typography.Text>
        </Space>
      }
      type="info"
    />
  );
};
